
<div class="container-tab-lists">
  <mat-tab-group mat-stretch-tabs="false" orientation="vertical" #tabGroup (selectedTabChange)="defaults.updateComponentTab($event.tab.textLabel)">
    <!--Messages-->
    <mat-tab label="Entity Data">
      <div class="inner-tcontainer-tab">
        <branchconfig (savedEvent)="onBranchConfigSaved($event)"></branchconfig>
        @if (waveId > 0) {
          <branchcontact></branchcontact>
        }
      </div>
    </mat-tab>
    @if (waveId > 0) {
      <mat-tab label="Entity Assessment">
        <div class="inner-tcontainer-tab">
          <div class="container-tab-lists new-table-style">
            <!--<h2>{{label}}</h2>-->
            <div style="display:flow-root">
              <div style="text-align:left; float:left; margin-top: 1em;">
                <h5 class="salmon-color">{{stageKPIWarning}}</h5>
              </div>
              <div style="text-align:right; float:right">
                @if (defaults.isMersyAdminBranchExcellenceUser && !isExcelModeEnabled && !isEditModeEnabled)
                {
                  <mat-slide-toggle #bestPracticesToggle labelPosition="before" [checked]="assessmentInfo?.IsBestPracticesCollected" (change)="onToggleChangeBestPractices($event.checked)">
                      Best Practices Collected
                  </mat-slide-toggle>
                }

                @if (!isExcelModeEnabled && !isEditModeEnabled && canEdit()) {
                  <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
                    Excel
                  </a>
                }

                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Dowload" (click)="onClickDownloadAssesmentConfig()">
                    <span class='glyphicon glyphicon-download'></span> Download
                  </a>
                }

                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Upload" (click)="onClickUploadAssesmentConfig()">
                    <span class='glyphicon glyphicon-upload'></span> Upload
                  </a>
                }

                @if (isExcelModeEnabled) {
                  <a class='kpi-button-menu' title="Excel" (click)="onClickExitExcel()">
                    Exit Excel Mode
                  </a>
                }

                @if (isEditModeEnabled) {
                  <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave('assessment')">
                    <span class='glyphicon glyphicon-floppy-disk'></span> Save
                  </a>
                }

                @if (canEdit()) {
                  <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
                    <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
                  </a>
                }
                <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
                  Edit Mode is enabled. Please click on Save button to save all changes
                </h5>
              </div>
            </div>
            <br />
            <assessment-list [childData]="childData"
              [stages]="stages"
            [isEditModeEnabled]="isEditModeEnabled"></assessment-list>
          </div>

        </div>
      </mat-tab>

      @if (getShowImprovementLeverTab()) {
        <mat-tab label="Improvement Levers">
          <div class="inner-tcontainer-tab">
            <div class="container-tab-lists new-table-style">
              <div style="display:flow-root">
                <div style="text-align:left; float:left; margin-top: 1em;">
                  <h5 class="salmon-color">{{leversMandatoryFieldsWarning}}</h5>
                </div>
                <div style="text-align:right; float:right">
                  @if (!isExcelModeEnabled && !isEditModeEnabled && canEdit()) {
                    <a class='kpi-button-menu' title="Excel" (click)="onClickExcel()">
                      Excel
                    </a>
                  }
                  @if (isExcelModeEnabled) {
                    <a class='kpi-button-menu' title="Dowload" (click)="onClickDownloadImprovementLevers()">
                      <span class='glyphicon glyphicon-download'></span> Download
                    </a>
                  }
                  @if (isExcelModeEnabled) {
                    <a class='kpi-button-menu' title="Upload" (click)="onClickUploadImprovementLevers()">
                      <span class='glyphicon glyphicon-upload'></span> Upload
                    </a>
                  }
                  @if (isExcelModeEnabled) {
                    <a class='kpi-button-menu' title="Excel" (click)="onClickExitExcel()">
                      Exit Excel Mode
                    </a>
                  }
                  @if (isEditModeEnabled) {
                    <a class='kpi-save-menu save-button' title="Save" (click)="onClickSave('priorities')">
                      <span class='glyphicon glyphicon-floppy-disk'></span> Save
                    </a>
                  }
                  @if (canEdit()) {
                    <a class='kpi-button-menu' title="Edit values" (click)="onClickEdit()">
                      <span class='glyphicon glyphicon-pencil'></span> {{isEditModeEnabled ? 'Undo' : 'Edit'}}
                    </a>
                  }
                  <h5 [style.visibility]="isEditModeEnabled === true ? 'visible' : 'hidden'">
                    Edit Mode is enabled. Please click on Save button to save all changes
                  </h5>
                </div>
              </div>
              <br />
              <action-priorization-list [childData]="childData"
                [isEditModeEnabled]="isEditModeEnabled"
              [priorities]="priorities"></action-priorization-list>
            </div>
          </div>
        </mat-tab>
      }
    }
  </mat-tab-group>
</div>